<template>
  <div>
    <div class="title-div">燃气户号管理-查找用户编号</div>
    <div>
      <br><br>
      <el-row>
        <el-col :span="6">&nbsp;</el-col>
        <el-col :span="4"><span class="firstTitle">获取燃气用户编号</span></el-col>
      </el-row>

      <br>
      <el-row>
        <el-col :span="7">&nbsp;</el-col>
        <el-col :span="17"><span class="content">燃气用户编号为11位数字，如果您的户号首位为“O”，请不要输入首位“O”。您可以通过如下几种途径获知用户编号:</span></el-col>
      </el-row>

      <br><br>
      <el-row>
        <el-col :span="6">&nbsp;</el-col>
        <el-col :span="10"><span class="secondTitle">1.从各类单据上获取</span></el-col>
      </el-row>

      <br>
      <el-row>
        <el-col :span="6">&nbsp;</el-col>
        <el-col :span="10"><span class="thirdTitle">（1）燃气卡</span></el-col>
      </el-row>
    </div>

    <br>
    <div>
      <div class="photo1">
        <img alt="" src="../../../assets/accountNumberManagement/card2.png" width="350px" >
        <span class="warning">*红框部分为需要提交的用户编号</span>
      </div>
    </div>

    <div>
      <br>
      <el-row>
        <el-col :span="6">&nbsp;</el-col>
        <el-col :span="10"><span class="thirdTitle">（2）购气凭证</span></el-col>
      </el-row>
    </div>

    <br><br>
    <div>
      <div style="display: inline" class="photo2"><img alt="" src="../../../assets/accountNumberManagement/card3.png" width="200px"></div>
      <div style="display: inline" class="photo3"><img alt="" src="../../../assets/accountNumberManagement/card4.png" width="470px"></div>
    </div>

    <div>
      <br>
      <span class="photoName1">IC卡购气凭证</span>
      <span class="photoName2">CPU卡购气凭证</span>
    </div>

    <div>
      <el-row>
        <el-col :span="6">&nbsp;</el-col>
        <el-col :span="10"><span class="thirdTitle">（3）缴费通知单</span></el-col>
      </el-row>
    </div>

    <div>
      <br><br>
      <div class="photo4">
        <img alt="" src="../../../assets/accountNumberManagement/card5.png" width="350px">
        <span class="warning">*红框部分为需要提交的用户编号</span>
      </div>
    </div>

    <div>
      <br><br>
      <el-row>
        <el-col :span="6">&nbsp;</el-col>
        <el-col :span="10"><span class="secondTitle">2.提报咨询单</span></el-col>
      </el-row>

      <br>
      <el-row>
        <el-col :span="7">&nbsp;</el-col>
        <el-col :span="17"><span class="content">如果找不到以上单据，您可拨打96777进行咨询，客服核实后会及时回复。</span></el-col>
      </el-row>
      <br><br><br><br>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'FindingUserNo'
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .firstTitle{
    font-size: 30px;
    font-weight:bold;
  }

  .secondTitle{
    font-size: 25px;
    font-weight:bold;
  }

  .thirdTitle{
    font-size: 20px;
    font-weight:bold;

  }
  .content{
    font-size: 18px;
  }

  .photo1{
    position: relative;
    left: 35%;
    width: 600px;
  }
  .photo2{
    position: relative;
    left: 35%;
  }

  .photo3{
    position: relative;
    left: 35%;
  }

  .photo4{
    position: relative;
    left: 35%;
    width: 600px;
  }
  .photoName1{
    position: relative;
    left: 38%;
    font-size: 18px;
  }

  .photoName2{
    position: relative;
    left: 52%;
    font-size: 18px;
  }

  .warning{
    color: red;
    font-size: 16px;
    font-weight:bold;

  }

</style>
